import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const containerStyles = ({ theme }) => css`
  label: container;

  background: ${theme.colors.white};
  height: 270px;
  width: 100%;
  top: calc(50vh - (-10vh) - 270px);
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 2;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`

const containerFooterStyles = ({ theme }) => css`
  label: container__footer;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  margin-bottom: ${theme.spacings.mega};
`

const overlayStyles = () => css`
  label: container__overlay;

  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background: black;
  opacity: 0.6;
  z-index: 1;
`

const titleStyles = ({ theme }) => css`
  label: container__title;

  display: block;

  margin-top: ${theme.spacings.mega};
  padding: 0 ${theme.spacings.mega};

  color: ${theme.colors.black};
  font-size: ${theme.typography.text.giga.fontSize};
  font-weight: ${theme.font.weight.semibold};
  line-height: ${theme.typography.text.giga.lineHeight};
  text-align: center;
`

const descriptionStyles = ({ theme }) => css`
  color: ${theme.colors.n400};
`

export const Container = styled('div')(containerStyles)
export const ContainerFooter = styled('div')(containerFooterStyles)
export const Overlay = styled('div')(overlayStyles)
export const Title = styled('span')(titleStyles)
export const Description = styled(Text)(descriptionStyles)
